import { IBlock } from './Step52.models';

export const emptyBlock = (block?: Partial<IBlock>): IBlock => ({
  id: 0,
  dropdownValue: '',
  firstInputValue: '',
  secondInputValue: '',
  ...block
});
